import React from 'react'
import image from 'assets/logo-spaceIQ-endorsement.svg'
import css from './logo.module.scss'
import { Link } from '@reach/router'
import { useAppData } from '@providers'

export default function Logo() {
  const setting = useAppData()
  return (
    <>
      <div className={css.container}>
        <Link to="/floor_plan">
          <img alt="logo" src={image} width={57} height={57} />
        </Link>
      </div>
      <div style={{ margin: '6px' }}>for</div>
      {setting?.assets && setting?.assets[0] && setting?.assets?.length ? (
        <div className={css.dark_container}>
          <Link to="/floor_plan">
            <img alt="logo" src={setting.assets[0]?.url} className={css.dark_logo} />
          </Link>
        </div>
      ) : (
        <div>{setting.name}</div>
      )}
    </>
  )
}
